import TYPES from '../../action-types';

/** Remove tmp items */
const removeTmpItems = () => ({ type: TYPES.ASSETS.REMOVE_TMP_ITEMS });

export default removeTmpItems;
